/** VUEX module for user management **/
import responseNotification from '../lib/responseNotification.js'

import {
  sendForgotPassword,
  updatePassword,
  updateBasicDetails,
  verifyPassword,
  loadFavorites,
  createFavorites,
  deleteFavorites,
  fetchAllUsers, updateUser,
  signupHubspotNotification
} from '../lib/api/calls'
import router from '../router/index';

export default {
  namespaced: true,
  state: {
    favorites: [],
    all: []
  },
  mutations: {
    setFavorites (state, value) {
      state.favorites = value;
    },
    setUsers (state, value) {
      state.all = value;
    }
  },
  actions: {
    loadAll ({commit}) {
      fetchAllUsers().then(users => {
        commit('setUsers', users)
      })
    },
    addFavorite (context, {format_id}) {
      createFavorites(format_id).then((response) => {
        context.dispatch('loadFavorites')
      })
    },
    async hubspotNewUser (context) {
      let email = context.rootState.me.email;
      let name = context.rootState.me.name;
      await signupHubspotNotification(email, name);
    },
    removeFavorite (context, {id}) {
      deleteFavorites(id).then((response) => {
        context.dispatch('loadFavorites')
      })
    },
    loadFavorites ({commit}) {
      loadFavorites().then(favorites => {
        commit('setFavorites', favorites)
      })
    },
    updatePassword (context, payload) {
      updatePassword(payload).then((result) => {
        responseNotification(context, result, 'Password updated!')
      }).catch((result) => {
        responseNotification(context,{error: 'Password update failed!'})
      })
    },
    updateBasicDetails (context, {userId, payload}) {
      updateBasicDetails(userId, payload).then((result) => {
        if (result.status == 422) {
          responseNotification(context, {error: 'This email is already taken by another user.'})
        } else {
          responseNotification(context, result, 'Basic Details Updated!')
          context.dispatch('loadMe', {}, {root: true});
          context.dispatch('accounts/loadOwned', {}, {root: true});
        }
      })
    },
    update(context, {userId, payload}) {
      updateUser(userId, payload).then((result) => {
        responseNotification(context, result, 'User Details Updated!')
        context.dispatch('users/loadAll', {}, {root: true});
      })
    },
    sendForgotPassword (context, {email, callback}) {
      sendForgotPassword(email).then((response) => {
        if (response.error) {
          responseNotification(context, response)
        } else {
          responseNotification(context, response, 'Check your email for password result instructions.')
          if (callback) callback()
        }
      })
    },
    verifyPassword (context, {token}) {
      verifyPassword(token).then((response) => {
        if (!response.error) {
          delete localStorage.password_token
          responseNotification(context, response, 'User Logged In!')
          router.push('/profile')
          location.reload()
        } else {
          responseNotification(context, response)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/users.js